import { useEffect, useState } from "react";
import { PopupPagoPaso2 } from "../../../popup";
import SelectProfesiones from "../SelectProfesiones";
import EligeCantidadPago from "../EligeCantidadPago";
import { ButtonPopup, ButtonSiguiente } from "../../../ui";
import { OcultarDatosCss, InputCss } from '../../../styles';
import { Datos2Props, FormErrors, PaymentOption, Profesion } from "@/types";
import { safeFetch } from "@/api/safeFetch";


const Datos2: React.FC<Datos2Props> = ({
    selectedProfesiones = [],
    handleProfesionSelect,
    paymentOption,
    paymentAmount,
    setPaymentDetails,
    setPaymentAmount = () => { },
    onPaymentChange,
    isFirmaAccepted,
    readOnly = false,
}) => {
    const [opciones, setOpciones] = useState<Profesion[]>([]);
    const [popupVisible, setPopupVisible] = useState(false);
    const [, setLoadingProfesiones] = useState(false);
    const [errors] = useState<FormErrors>({}); // Para manejar errores
    const [selectedPaymentOption, setSelectedPaymentOption] = useState<PaymentOption>("Anual");
  
    useEffect(() => {
        const fetchProfesiones = async () => {
            setLoadingProfesiones(true);
            try {
                const response = await safeFetch(`/api/profesiones/sacarProfesion/registrarse`,);
                if (!response.ok) throw new Error("Error al obtener las profesiones");
                const data: Profesion[] = await response.json();
                setOpciones(data);
            } catch (error) {
                console.error("Error fetching profesiones:", error);
            } finally {
                setLoadingProfesiones(false);
            }
        };
        fetchProfesiones();
    }, []);

    // Calcular total sin IVA
    const calculateTotal = (): number => {
        const costoPorProfesion = paymentAmount!;  // Si paymentAmount es undefined, usa 0
        return Array.isArray(selectedProfesiones) ? selectedProfesiones.length * costoPorProfesion : 0;
    };

    useEffect(() => {
        if (paymentOption) {
          setSelectedPaymentOption(paymentOption as PaymentOption);
        }
      }, [paymentOption]);
      
      

      const handlePaymentOptionChange = (option: PaymentOption, amount: number) => {
        setSelectedPaymentOption(option);
        setPaymentDetails?.(option, amount);
        onPaymentChange?.(option, amount); // <-- importante que 'Pago' escuche esto
    };
    
      
      

    const closePopup = () => {
        setPopupVisible(false);
    };


    return (
        <div className={`datos2 ${isFirmaAccepted ? `${OcultarDatosCss.niebla}` : ""} xs:col-span-12 sm:col-span-12 md:col-span-4 px-3 py-1 space-y-2 rounded-md border dark:bg-white dark:text-zinc-700 ${InputCss.inputEdita}`}>
            <div className="flex flex-col justify-between h-full">
                <div>
                    <h3 className="font-semibold underline">Detalles seleccionados:</h3>
                    <div>
                        <h4 className="font-semibold">Profesión:</h4>
                        {Array.isArray(selectedProfesiones) && selectedProfesiones.length > 0 ? (
                            selectedProfesiones.map((profesion: string, index: number) => (
                                <p key={index} className="text-md ml-1">{profesion}</p>
                            ))
                        ) : (
                            <p className="text-sm">No se ha seleccionado ninguna profesión.</p>
                        )}
                    </div>
                    <div>
                        <h4 className="font-semibold">Total a pagar:</h4>
                        <p className="text-md ml-1">{calculateTotal().toFixed(2)} € <small className="text-xs">Sin IVA</small></p>
                    </div>
                </div>
                <div className="flex justify-center pb-3">
                    <ButtonSiguiente type="button" className="w-full" onClick={() => setPopupVisible(true)}>
                        Editar profesión & pago
                    </ButtonSiguiente>
                </div>
            </div>

            {/* Popup para cambiar de ultima hora la suscripción de profesión y del pago */}
            {popupVisible && (
                <PopupPagoPaso2 isOpen={popupVisible} onClose={closePopup}>
                    <div className="w-full space-y-4">
                        <SelectProfesiones
                            label="Selecciona tu profesión :"
                            nombresProfesiones={opciones.map((opcion) => opcion.nombre_profesion)}
                            selectedProfesiones={selectedProfesiones}
                            onSelectionChange={handleProfesionSelect}
                            errors={errors} 
                            readOnly={readOnly} //Aqui se bloquea para no lo edite cuando renueve suscripción
                            className={`w-full truncate overflow-hidden px-3 py-2 rounded-md border 
                            text-zinc-700
                            cursor-text
                            shadow-[inset_-2px_-2px_1px_rgb(99,105,112)]
                            focus:shadow-[inset_2px_3px_2px_rgb(24,25,27)]
                            outline-none
                            transition-all duration-200 ${errors?.selectedProfession ? 'bg-red-100' : ''}`}
                       />
                        <EligeCantidadPago
                            selectedPaymentOption={selectedPaymentOption}
                            setSelectedPaymentOption={setSelectedPaymentOption}
                            setPaymentAmount={setPaymentAmount}
                            paymentAmount={paymentAmount}
                            onPaymentChange={handlePaymentOptionChange} 
                            errors={errors} 
                        />
                        <ButtonPopup onClick={closePopup}>
                            Cerrar
                        </ButtonPopup>
                    </div>
                </PopupPagoPaso2>
            )}

        </div>
    );
};

export default Datos2;
